import { render } from "./LogoFooter.vue?vue&type=template&id=2e8e483f&scoped=true"
import script from "./LogoFooter.vue?vue&type=script&lang=js"
export * from "./LogoFooter.vue?vue&type=script&lang=js"

import "./LogoFooter.vue?vue&type=style&index=0&id=2e8e483f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8e483f"]])

export default __exports__